'use client';

import type { ReactElement } from 'react';
import { GanttBarMotionGroup } from './GanttBarMotionGroup';
import { selectGanttBarRenderModel } from './gantt-bar-selectors';
import type { GanttTaskLayout } from './gantt-types';

export interface GanttBarProps {
  taskLayout: GanttTaskLayout;
  color: string;
  gradientId: string;
  patternId: string;
  glowFilterId: string;
  isDimmed: boolean;
  isHovered: boolean;
  rowIndex: number;
}

export function GanttBar({
  taskLayout,
  color,
  gradientId,
  patternId,
  glowFilterId,
  isDimmed,
  isHovered,
  rowIndex,
}: GanttBarProps): ReactElement | null {
  const renderModel = selectGanttBarRenderModel({
    taskLayout,
    color,
    gradientId,
    patternId,
    glowFilterId,
    isDimmed,
    isHovered,
    rowIndex,
  });

  if (!renderModel) {
    return null;
  }

  return <GanttBarMotionGroup renderModel={renderModel} />;
}
